var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        "offset-y": "",
        left: "",
        top: _vm.top,
        "close-on-content-click": !_vm.keepOpenOnContentClick,
        "nudge-top": _vm.top ? 8 : 0,
        "nudge-bottom": _vm.top ? 0 : 8,
        transition: "slide-y-transition",
        "content-class": _vm.contentClass,
        "min-width": _vm.menuWidth,
        "max-width": _vm.menuWidth
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _vm.iconOnly
                ? _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            icon: "",
                            small: "",
                            "aria-label": _vm.label
                          }
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _vm.isLoading
                        ? _c("v-progress-circular", {
                            attrs: {
                              indeterminate: "",
                              size: 16,
                              width: 2,
                              color: "primary"
                            }
                          })
                        : _c("icon-svg", {
                            attrs: {
                              name: "mdi-dots-vertical",
                              size: 18,
                              color: _vm.COR_ICONE_ACAO
                            }
                          })
                    ],
                    1
                  )
                : _c(
                    "BaseButton",
                    _vm._g(
                      _vm._b(
                        { attrs: { bordered: "", fitContent: "" } },
                        "BaseButton",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _vm._v(" " + _vm._s(_vm.label) + " "),
                      _c(
                        "span",
                        { staticClass: "base-actions-menu__trailing" },
                        [
                          _vm.isLoading
                            ? _c("v-progress-circular", {
                                attrs: {
                                  indeterminate: "",
                                  size: 16,
                                  width: 2,
                                  color: "primary"
                                }
                              })
                            : _c("icon-svg", {
                                staticClass: "base-actions-menu__chevron",
                                class: {
                                  "base-actions-menu__chevron--open": _vm.menu
                                },
                                attrs: {
                                  name: "mdi-chevron-down",
                                  size: 18,
                                  color: _vm.COR_ICONE_ACAO
                                }
                              })
                        ],
                        1
                      )
                    ]
                  )
            ]
          }
        }
      ]),
      model: {
        value: _vm.menu,
        callback: function($$v) {
          _vm.menu = $$v
        },
        expression: "menu"
      }
    },
    [
      _c(
        "div",
        { staticClass: "base-actions-menu__panel" },
        [
          _vm.regularActions.length
            ? _c(
                "div",
                { staticClass: "base-actions-menu__list" },
                _vm._l(_vm.regularActions, function(action, index) {
                  return _c(
                    "button",
                    {
                      key: index,
                      staticClass: "base-actions-menu__item",
                      attrs: {
                        type: "button",
                        disabled: action.disabled || action.loading,
                        "data-tour": action.dataTour
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleAction(action)
                        }
                      }
                    },
                    [
                      action.loading
                        ? _c("v-progress-circular", {
                            attrs: {
                              indeterminate: "",
                              size: 15,
                              width: 2,
                              color: _vm.COR_ICONE_ACAO
                            }
                          })
                        : action.icon
                        ? _c("icon-svg", {
                            attrs: {
                              name: action.icon,
                              size: 15,
                              color: action.iconColor || _vm.COR_ICONE_ACAO
                            }
                          })
                        : _vm._e(),
                      _c(
                        "span",
                        { staticClass: "base-actions-menu__item-text" },
                        [
                          _c("span", [_vm._v(_vm._s(action.label))]),
                          action.description
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "base-actions-menu__item-description"
                                },
                                [_vm._v(" " + _vm._s(action.description) + " ")]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._t("default"),
          _vm.destructiveActions.length
            ? _c(
                "div",
                {
                  staticClass:
                    "base-actions-menu__list base-actions-menu__list--danger"
                },
                _vm._l(_vm.destructiveActions, function(action, index) {
                  return _c(
                    "button",
                    {
                      key: index,
                      staticClass:
                        "base-actions-menu__item base-actions-menu__item--danger",
                      attrs: {
                        type: "button",
                        disabled: action.disabled || action.loading,
                        "data-tour": action.dataTour
                      },
                      on: {
                        click: function($event) {
                          return _vm.handleAction(action)
                        }
                      }
                    },
                    [
                      action.loading
                        ? _c("v-progress-circular", {
                            attrs: {
                              indeterminate: "",
                              size: 15,
                              width: 2,
                              color: "danger"
                            }
                          })
                        : action.icon
                        ? _c("icon-svg", {
                            attrs: {
                              name: action.icon,
                              size: 15,
                              color: "danger"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" " + _vm._s(action.label) + " ")
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }